import { render, staticRenderFns } from "./Rule_Pokdeng2.vue?vue&type=template&id=19555b0d&scoped=true&"
import script from "./Rule_Pokdeng2.vue?vue&type=script&lang=js&"
export * from "./Rule_Pokdeng2.vue?vue&type=script&lang=js&"
import style0 from "./Rule_Pokdeng2.vue?vue&type=style&index=0&id=19555b0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19555b0d",
  null
  
)

export default component.exports